import React, { Fragment, useEffect, useState } from "react";
import "./dashboard.css";
import organization_icon from "../../assets/images/insight-admin.svg";
import document_superadmin from "../../assets/images/document_superadmin.png";
import message_superadmin from "../../assets/images/message_superadmin.png";
import application_superadmin from "../../assets/images/application_superadmin.png";
import groups_people_superadmin from "../../assets/images/groups_people_superadmin.png";
import workflows_superadmin from "../../assets/images/workflows_superadmin.png";
import hospital_superadmin from "../../assets/images/hospital_superadmin.png";
import support_supperadmin from "../../assets/images/support_supperadmin.png";
import support_supperadmin_qa from "../../assets/images/support_supperadmin_qa.png";
import support_supperadmin_la from "../../assets/images/support_supperadmin_la.png";
import Revenue_superadmin from "../../assets/images/Revenue_superadmin.png";
import application_form_superadmin from "../../assets/images/application_form_superadmin.png";
import application_form_superadmin_qa from "../../assets/images/application_form_superadmin_qa.png";
import organizatio_superadmin from "../../assets/images/organizatio_superadmin.png";
import organizatio_superadmin_qa from "../../assets/images/organizatio_superadmin_qa.png";
import patient_superadmin from "../../assets/images/patient_superadmin.png";
import user_superadmin from "../../assets/images/user_superadmin.png";
import user_superadmin_qa from "../../assets/images/user_superadmin_qa.png";
import quick_action_superadmin from "../../assets/images/quick_action_superadmin.png";
import activity_icon_superadmin from "../../assets/images/activity_icon_superadmin.png";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { getAllCountList, getAllOrg } from "../../api/orgnizations";
import { useDispatch, useSelector } from "react-redux";
import { failed } from "../../utils/Tostify";
import { useNavigate } from "react-router";
import AddApplicationType from "../workflow/ApplicationType/AddApplicationType";
import AddDocumentType from "../workflow/DocumentType/AddDocumentType";
import AddForm from "../workflow/Forms/AddForm";
import AddWorkflow from "../workflow/CreateWorkflow/AddWorkflow";
import CreateUser from "../users/user/CreateUser";
import { getAllRequests } from "../../api/Applications";
import CustomPagination from "../../components/Pagination/CustomPagination";
import AddOrganization from "../orgnization/AddOrganization";
import CreatePlatformRequest from "../support/CreatePlatformSupportRequest";
import AddRoles from "../users/roles/AddRoles";
import ComposeMessage from "../messages/ComposeMessage";
import { getUserMessages } from "../../api/User";
import { decryptData } from "../../utils/helper";
import { Link } from "react-router-dom";
import { getAllActivity } from "../../api/Activity";


function AdminDashboard() {
    const [showModal, setShowModal] = useState(false);
    const [supportRequestsList, setSupportRequestsList] = useState([]);
    const userRole = localStorage.getItem("userRole");
    let user = useSelector((state) => state?.userReducer?.user);
    let token = useSelector(state => state.userReducer.token);
    const [isLoading, setIsLoading] = useState(false);
    const [activityList, setActivityList] = useState([]);
    const [countData, setCountData] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const dispatch = useDispatch();
    const [CurrentTab, setCurrentTab] = useState("formList");
    const ITEMS_PER_PAGE = 5;
    const [composeModal, setComposeModal] = useState(false);
    const [folder, setFolder] = useState("Inbox");
    const navigate = useNavigate();
    const [showOrgModal, setShowOrgModal] = useState(false);
    const [orgList, setOrgList] = useState([]);
    const [sortBy, setSortBy] = useState({
        column: "",
        desc: false
    });

    const toggleComposeModal = () => {
        setComposeModal(!composeModal);
    };

    const getCountList = async () => {
        let res = "";
        try {
            setIsLoading(true);
            const payload = { orgId: localStorage.getItem("currentOrgId"), clinicId: localStorage.getItem("currentHospitalId"), userId: user._id };
            res = await getAllCountList({ values: payload, dispatch, token });
            if (res?.status === "SUCCESS") {
                setCountData(res?.data);
                setIsLoading(false);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };

    const getSupportRequestList = async (page, limit, searchKey = "") => {
        let res;
        try {
            setIsLoading(true);

            res = await getAllRequests({ token, userId: user._id, userRole: userRole });

            const responseData = decryptData(res.data);
            if (res?.status === "SUCCESS") {
                setSupportRequestsList(responseData?.list);
                setIsLoading(false);
            }
        } catch (error) {
            failed(res?.message || "Something went wrong while fetching support requests");
            setIsLoading(false);
        }
    };

    const fetchMessages = async (folder = "Inbox", searchKey = "") => {
        setIsLoading(true);
        let res;
        try {
            const values = { folder, searchKey, ...(folder === "Inbox" ? { userId: user._id } : { userId: user._id }) };
            res = await getUserMessages({ values, dispatch, token });
            if (res?.status === "SUCCESS") {
                setFolder(folder);
            } else {
                setIsLoading(false);
                failed(res?.message);
            }
        } catch (error) {
            setIsLoading(false);
            failed(res?.message);
        } finally {
            setIsLoading(false);
        }
    };

    const getActivityList = async (page, limit) => {
        let res;
        try {
            setIsLoading(true);
            res = await getAllActivity({ dispatch, token, page, limit });
            const responseData = res?.data;
            const decryptResult = decryptData(responseData);
            if (res?.status === "SUCCESS") {
                setActivityList(decryptResult);
                setIsLoading(false);
            }
        } catch (error) {
            failed(res?.message || "Something went wrong while fetching support requests");
            setIsLoading(false);
        }
    };

    const handleActivityPagination = (page) => {
        getActivityList(page, 5);
    };

    const getOrgList = async () => {
        let res;
        try {
            setIsLoading(true);
            res = await getAllOrg({ dispatch, token });
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
                setOrgList(responseData);
                setIsLoading(false);
            } else {
                failed(res?.message);
            }
        } catch (error) {
            failed(error?.message || "Error fetching organizations");
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getCountList();
        getOrgList();
        getSupportRequestList();
        getActivityList(1, 5);
        fetchMessages();
    }, []);

    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const paginatedSupportList = supportRequestsList?.slice(startIndex, endIndex);

    const handlePagination = (page) => {
        setCurrentPage(page);
    };

    const renderView = () => {
        switch (CurrentTab) {
            case "addApplicationType":
                return <AddApplicationType setCurrentTab={setCurrentTab} />;
            case "addDocumentType":
                return <AddDocumentType setCurrentTab={setCurrentTab} />;
            case "addForm":
                return <AddForm setCurrentTab={setCurrentTab} />;
            case "addWorkflow":
                return <AddWorkflow setCurrentTab={setCurrentTab} />;
            case "createUser":
                return <CreateUser setCurrentTab={setCurrentTab} />;
            case "addOrganization":
                return <AddOrganization setCurrentTab={setCurrentTab} />;
            case "support":
                return <CreatePlatformRequest setCurrentTab={setCurrentTab} />;
            case "createRoles":
                return <AddRoles setCurrentTab={setCurrentTab} />;
            case "messages":
                return <ComposeMessage isOpen={true} toggle={toggleComposeModal} folder={folder} setCurrentTab={setCurrentTab} />;
            default:
                return null;
        }
    };

    const handleOpenModal = (tab) => {
        setShowOrgModal(true);
        setCurrentTab(tab);
    };

    const handleCloseOrgModal = () => {
        setShowOrgModal(false);
    };

    // Handle Organization Selection & Redirect
    const handleOrgSelect = (orgData) => {
        navigate("/super-admin/orgViewDetail", { state: { orgData } });
        localStorage.setItem("addHospital", true);
        setShowOrgModal(false);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleRedirect = () => {
        navigate("/super-admin/workflow", { state: { tab: "addWorkflow" } });
    };

    const handleUserRedirect = () => {
        navigate("/super-admin/users", { state: { tab: "createUser" } });
    };

    const handleSupportRedirect = () => {
        navigate("/super-admin/support", { state: { createRequest: true } });
    };

    const handleRoleRedirect = () => {
        navigate("/super-admin/users", { state: { tab: "addRoles" } });
    };

    const handleApplnTypeRedirect = () => {
        navigate("/super-admin/workflow", { state: { tab: "addApplicationType" } });
    };

    const handleUploadPdfRedirect = () => {
        navigate("/super-admin/workflow", { state: { tab: "addForm" } });
    };

    const handleDocTypeRedirect = () => {
        navigate("/super-admin/workflow", { state: { tab: "addDocumentType" } });
    };

    const handleMessagesRedirect = () => {
        navigate("/super-admin/messages", { state: { openCompose: true } });
    };

    const handleSort = (column) => {
        setSortBy((prevSortBy) => {
            const isSameColumn = column === prevSortBy.column;
            return {
                column,
                desc: isSameColumn ? !prevSortBy.desc : false
            };
        });

        const sortDirection = sortBy.column === column && !sortBy.desc ? -1 : 1; // Adjust sort direction

        const sortedRequest = [...paginatedSupportList].sort((a, b) => {
            if (column === "ticketId") {
                // Extract numeric part from "CA-000003" -> 3
                const numA = parseInt(a.ticketId.split("-")[1], 10);
                const numB = parseInt(b.ticketId.split("-")[1], 10);
                return (numA - numB) * sortDirection;
            } else if (column === "createdAt") {
                // Sort by createdAt (dates)
                const dateA = new Date(a.createdAt);
                const dateB = new Date(b.createdAt);
                return (dateA - dateB) * sortDirection;
            }
            return 0; // Default return if no column matches
        });

        setSupportRequestsList(sortedRequest); // Update the state with sorted data
    };

    return (
        <Fragment>
            <div className="super-admin-home table_listing_color">
                <div className="super-admin-insights_block">
                    <div className="admin-insights d-flex align-items-center insights-bg">
                        <img src={organization_icon} height={50}/>
                        <h2 className="super-title title-blocks m-0">Insights</h2>
                    </div>
                    <div className="cards row admin-home">
                        <div className="col-xxl-2 col-lg-4 col-md-6 mb-25">
                            <div className="card-item cards-super d-flex total_user">
                                <div className="card-img">
                                    <img src={user_superadmin} alt="" className="user-icon-block" />
                                </div>
                                <div className="card-data">
                                    <h3>{countData?.allUserCount ? countData?.allUserCount : 0}</h3>
                                    <p className="admin-block-text">Total Users</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-2 col-lg-4 col-md-6 mb-25">
                            <div className="card-item cards-super d-flex total_org">
                                <div className="card-img">
                                    <img src={organizatio_superadmin} alt="" />
                                </div>
                                <div className="card-data">
                                    <h3>{countData?.allOrgCount ? countData?.allOrgCount : 0}</h3>
                                    <p className="admin-block-text">Total Organizations</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-2 col-lg-4 col-md-6 mb-25">
                            <div className="card-item cards-super d-flex total_applications">
                                <div className="card-img">
                                    <img src={application_form_superadmin} alt="" />
                                </div>
                                <div className="card-data">
                                    <h3>{countData?.allApplicationCountSuperAdmin ? countData?.allApplicationCountSuperAdmin : 0}</h3>
                                    <p className="admin-block-text">Total Applications</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-2 col-lg-4 col-md-6 mb-25">
                            <div className="card-item cards-super d-flex total_admin_patient">
                                <div className="card-img">
                                    <img src={patient_superadmin} alt="" />
                                </div>
                                <div className="card-data">
                                    <h3>{countData?.allDBPatientCount ? countData?.allDBPatientCount : 0}</h3>
                                    <p className="admin-block-text">Total Patients</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-2 col-lg-4 col-md-6 mb-25">
                            <div className="card-item cards-super d-flex total_staff">
                                <div className="card-img">
                                    <img src={support_supperadmin} alt="" />
                                </div>
                                <div className="card-data">
                                    <h3>{countData?.allSupportCount ? countData?.allSupportCount : 0}</h3>
                                    <p className="admin-block-text">Total Support</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-2 col-lg-4 col-md-6 mb-25">
                            <div className="card-item cards-super d-flex total_actions">
                                <div className="card-img">
                                    <img src={Revenue_superadmin} alt="" />
                                </div>
                                <div className="card-data">
                                    <h3>{countData?.allApplicationTasksCount ? countData?.allApplicationTasksCount : 0}</h3>
                                    <p className="admin-block-text">Total Actions</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="super-admin-insights_block">
                    <div className="admin-insights d-flex align-items-center quick-bg">
                        <img src={quick_action_superadmin} height="60"/>
                        <h2 className="super-title title-blocks m-0">Quick Actions</h2>
                    </div>
                    <div className="main_buttons">
                        <div className="button_cards d-flex justify-content-between">
                            <Link to="/super-admin/addOrganization" className="card_pallet">
                                <div className="main_card d-flex align-items-center">
                                    <div className="d-flex align-items-center card-quick-img">
                                        <img src={organizatio_superadmin_qa} alt="" />
                                        </div>
                                        <div className="card-data">
                                        <h4 className="second_card_actions">Organizations</h4>
                                    </div>
                                </div>
                                <button className="plus_block">
                                    <i className="fa fa-plus"></i>
                                </button>
                            </Link>
                            <div className="card_pallet" onClick={handleOpenModal}>
                                <div className="main_card d-flex align-items-center">
                                    <div className="d-flex align-items-center card-quick-img">
                                        <img src={hospital_superadmin} alt="" />
                                        </div>
                                        <div className="card-data">
                                        <h4 className="second_card_actions">Hospital Clinic</h4>
                                    </div>
                                </div>
                                <button className="plus_block">
                                    <i className="fa fa-plus"></i>
                                </button>
                            </div>
                            <div className="card_pallet" onClick={handleRedirect}>
                                <div className="main_card d-flex align-items-center">
                                    <div className="d-flex align-items-center card-quick-img">
                                        <img src={workflows_superadmin} alt="" />
                                        </div>
                                        <div className="card-data">
                                        <h4 className="second_card_actions">Workflows</h4>
                                    </div>
                                </div>
                                <button className="plus_block">
                                    <i className="fa fa-plus"></i>
                                </button>
                            </div>
                            <div className="card_pallet" onClick={handleUserRedirect}>
                                <div className="main_card d-flex align-items-center">
                                    <div className="d-flex align-items-center card-quick-img">
                                        <img src={user_superadmin_qa} alt="" />
                                        </div>
                                        <div className="card-data">
                                        <h4 className="second_card_actions">Users</h4>
                                    </div>
                                </div>
                                <button className="plus_block">
                                    <i className="fa fa-plus"></i>
                                </button>
                            </div>
                            <div className="card_pallet" onClick={handleSupportRedirect}>
                                <div className="main_card d-flex align-items-center">
                                    <div className="d-flex align-items-center card-quick-img">
                                        <img src={support_supperadmin_qa} alt="" />
                                        </div>
                                        <div className="card-data">
                                        <h4 className="second_card_actions">Support</h4>
                                    </div>
                                </div>
                                <button className="plus_block">
                                    <i className="fa fa-plus"></i>
                                </button>
                            </div>
                            <div className="card_pallet" onClick={handleRoleRedirect}>
                                <div className="main_card d-flex align-items-center">
                                    <div className="d-flex align-items-center card-quick-img">
                                        <img src={groups_people_superadmin} alt="" />
                                        </div>
                                        <div className="card-data">
                                        <h4 className="second_card_actions">Roles</h4>
                                    </div>
                                </div>
                                <button className="plus_block">
                                    <i className="fa fa-plus"></i>
                                </button>
                            </div>
                            <div className="card_pallet" onClick={handleUploadPdfRedirect}>
                                <div className="main_card d-flex align-items-center">
                                    <div className="d-flex align-items-center card-quick-img">
                                        <img src={application_form_superadmin_qa} alt="" />
                                        </div>
                                        <div className="card-data">
                                        <h4 className="second_card_actions">Application Forms</h4>
                                    </div>
                                </div>
                                <button className="plus_block">
                                    <i className="fa fa-plus"></i>
                                </button>
                            </div>
                            <div className="card_pallet" onClick={handleApplnTypeRedirect}>
                                <div className="main_card d-flex align-items-center">
                                    <div className="d-flex align-items-center card-quick-img">
                                        <img src={application_superadmin} alt="" />
                                        </div>
                                        <div className="card-data">
                                        <h4 className="second_card_actions">Application Types</h4>
                                    </div>
                                </div>
                                <button className="plus_block">
                                    <i className="fa fa-plus"></i>
                                </button>
                            </div>
                            <div className="card_pallet" onClick={handleMessagesRedirect}>
                                <div className="main_card d-flex align-items-center">
                                    <div className="d-flex align-items-center card-quick-img">
                                        <img src={message_superadmin} alt="" />
                                        </div>
                                        <div className="card-data">
                                        <h4 className="second_card_actions">Messages</h4>
                                    </div>
                                </div>
                                <button className="plus_block">
                                    <i className="fa fa-plus"></i>
                                </button>
                            </div>
                            <div className="card_pallet" onClick={handleDocTypeRedirect}>
                                <div className="main_card d-flex align-items-center">
                                    <div className="d-flex align-items-center card-quick-img">
                                        <img src={document_superadmin} alt="" />
                                        </div>
                                        <div className="card-data">
                                        <h4 className="second_card_actions">Document Type</h4>
                                    </div>
                                </div>
                                <button className="plus_block">
                                    <i className="fa fa-plus"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row table_block_superadmin">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="super-admin-insights_block m-0 h-100">
                            <div className="admin-insights d-flex align-items-center support-bg">
                                <img src={support_supperadmin_la} height="50"/>
                                <h2 className="super-title title-blocks m-0">Support</h2>
                            </div>
                            <div className="table_space profile_main_two">
                                <div className="table-responsive">
                                    <table>
                                        <thead>
                                            <tr className="header_table">
                                                <th>
                                                    Ticket ID
                                                    <i
                                                        onClick={() => handleSort("ticketId")}
                                                        className='fas fa-sort'>
                                                    </i>
                                                </th>
                                                <th>
                                                    Created
                                                    <i
                                                        onClick={() => handleSort("createdAt")}
                                                        className='fas fa-sort'>
                                                    </i>
                                                </th>
                                                <th>
                                                    Created By
                                                </th>
                                                <th>
                                                    Assigned To
                                                </th>
                                                <th>
                                                    Category
                                                </th>
                                                <th>
                                                    Status
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paginatedSupportList?.map((request, index) => (
                                                <React.Fragment key={request?._id || index}>
                                                    <tr>
                                                        <td colSpan={9} height={5} className="bg_light"></td>
                                                    </tr>
                                                    <tr className={index % 2 === 0 ? "first_row" : "second_block"}>
                                                        <td><Link to={"/app/support/supportDetails"} state={{ supportData: request }}>{request.ticketId}</Link></td>
                                                        <td>{new Date(request.createdAt).toLocaleDateString()}</td>
                                                        <td>{request?.createdBy?.firstName || "N/A"} {request?.createdBy?.lastName || ""}</td>
                                                        <td>{request?.assignedTo?.firstName || "Unassigned"} {request?.assignedTo?.lastName || ""}</td>
                                                        <td>{request?.category || "N/A"}</td>
                                                        <td>{request?.status || "N/A"}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={9} height={5} className="bg_light"></td>
                                                    </tr>
                                                </React.Fragment>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className='d-flex justify-content-end'>
                                    <CustomPagination
                                        totalPages={Math.ceil(supportRequestsList?.length / ITEMS_PER_PAGE)}
                                        totalRows={supportRequestsList?.length}
                                        rowsPerPage={ITEMS_PER_PAGE}
                                        page={currentPage}
                                        handlePage={handlePagination}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="super-admin-insights_block m-0 h-100">
                            <div className="admin-insights d-flex align-items-center active_bg">
                                <img src={activity_icon_superadmin} height="50"/>
                                <h2 className="super-title title-blocks m-0">Activity</h2>
                            </div>
                            <div className="table_space profile_main_two">
                                <div className="table-responsive">
                                    <table>
                                        <thead>
                                            <tr className="header_table">
                                                <th>
                                                    Timestamp
                                                </th>
                                                <th>
                                                    Acitivity
                                                </th>
                                                <th>
                                                    User
                                                </th>
                                                <th>
                                                    Role
                                                </th>
                                                <th>
                                                    Organization
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {activityList?.items?.map((activity, index) => (
                                                <React.Fragment key={activity?._id || index}>
                                                    <tr>
                                                        <td colSpan={9} height={5} className="bg_light"></td>
                                                    </tr>
                                                    <tr key={index} className={index % 2 === 0 ? "first_activity_row" : "second_block"}>
                                                        <td>{new Date(activity.createdAt).toLocaleString()}</td>
                                                        <td>{activity.event}</td>
                                                        <td>{activity.user?.firstName} {activity.user?.lastName}</td>
                                                        <td>{activity?.user?.defaultRoleData?.roleName}</td>
                                                        <td>{activity.organization?.name || "N/A"}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={9} height={5} className="bg_light"></td>
                                                    </tr>
                                                </React.Fragment>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className='d-flex justify-content-end'>
                                <CustomPagination
                                    tableData={activityList?.items}
                                    totalPages={activityList?.totalPages}
                                    totalRows={activityList.totalItems}
                                    rowsPerPage={5}
                                    page={activityList?.items?.length > 0 ? activityList?.currentPage : 0}
                                    handlePage={handleActivityPagination}
                                />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Modal to show renderView */}
                <Modal isOpen={showModal} toggle={handleCloseModal} size="xl" centered>
                    <ModalHeader toggle={handleCloseModal}></ModalHeader>
                    <ModalBody>
                        {renderView()}
                    </ModalBody>
                </Modal>
                {/* Modal for Organization Selection */}
                <Modal isOpen={showOrgModal} toggle={handleCloseOrgModal} size="md" centered>
                    <ModalHeader toggle={handleCloseOrgModal} className="org_select">Select an Organization</ModalHeader>
                    <ModalBody>
                        <select
                            className="form-control"
                            onChange={(e) => handleOrgSelect(JSON.parse(e.target.value))}
                        >
                            <option value="">Select Organization</option>
                            {orgList?.map((org) => (
                                <option key={org._id} value={JSON.stringify(org)}>
                                    {org.name}
                                </option>
                            ))}
                        </select>
                    </ModalBody>
                </Modal>
            </div>
        </Fragment>
    );
}

export default AdminDashboard;
